'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

// The form component will define the full state, this can be partial
export interface AspirationFormState {
  name: string;
  desiredVisaDetail: string;
  jobSearchStatus: string;
  desiredIndustry: string[];
  desiredJob: string[];
  desiredLocation: string[];
  targetAudience: string;
  specialConditions: string[];
  japaneseLevel: {
    jlpt: string;
    kaiwa: string;
    knowsJapanese?: boolean;
  };
  experience: string[];
  currentVisa: string;
  startDate: string;
  dateOfBirth?: number | null;
  gino1Remaining?: string;
  gino2Remaining?: string;
  documents: string[];
  trainingNeeds: string[];
  tokuteiClassSupport: string;
  tokuteiClassIndustry: string[];
  termsAgreed: boolean;
  uploadedDocuments: { [key: string]: { url: string; key: string }[] };
  filesToDelete: string[]; // <-- New field
  reasonForChoosing: string;
  strengthsWeaknesses: string;
  hobbies: string[];
  allergies: string[];
  [key: string]: any; // For any additional dynamic fields
}

export const initialState: AspirationFormState = {
  name: '',
  desiredVisaDetail: '',
  jobSearchStatus: '',
  desiredIndustry: [],
  desiredJob: [],
  desiredLocation: [],
  targetAudience: 'Cả nam và nữ',
  specialConditions: [],
  japaneseLevel: {
    jlpt: '',
    kaiwa: '',
    knowsJapanese: true,
  },
  experience: [],
  currentVisa: '',
  startDate: '',
  dateOfBirth: undefined,
  gino1Remaining: '',
  gino2Remaining: '',
  documents: [],
  trainingNeeds: [],
  tokuteiClassSupport: '',
  tokuteiClassIndustry: [],
  termsAgreed: false,
  uploadedDocuments: {},
  filesToDelete: [], // <-- Initialize
  reasonForChoosing: '',
  strengthsWeaknesses: '',
  hobbies: [],
  allergies: [],
};

interface TaoHoSoContextType {
  formData: AspirationFormState;
  setFormData: React.Dispatch<React.SetStateAction<AspirationFormState>>;
  resetForm: () => void;
}

const TaoHoSoContext = createContext<TaoHoSoContextType | undefined>(undefined);

export const useTaoHoSo = () => {
  const context = useContext(TaoHoSoContext);
  if (!context) {
    throw new Error('useTaoHoSo must be used within a TaoHoSoProvider');
  }
  return context;
};

export const TaoHoSoProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState<AspirationFormState>(initialState);

  const resetForm = () => {
    setFormData(initialState);
  };

  const value = {
    formData,
    setFormData,
    resetForm,
  };

  return (
    <TaoHoSoContext.Provider value={value}>
      {children}
    </TaoHoSoContext.Provider>
  );
};
